import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

export const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

export const logoutSlice = createSlice({
  name: 'LOGOUT',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error.message = action.payload.message;
      state.error.statusCode = action.payload.statusCode;
    },
  },
});

// REDECER
export default logoutSlice.reducer;

// ACTIONS
export const { loading, success, failure } = logoutSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.authentication.logout.isLoading;
export const selectSuccess = (state: RootState) => state.ui.authentication.logout.success;
export const selectError = (state: RootState) => state.ui.authentication.logout.error;
